export default (width = 26, height = 26, color = '#309A02', number) => `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 26 26">
        <g fill="none" fill-rule="evenodd"><circle cx="13" cy="13" r="12" fill="${color}" stroke="${color}" stroke-width="2"/>
            <text fill="#F5F5F5" font-family="Lato-Bold, Lato" font-size="13" font-weight="bold" letter-spacing=".438">
                <tspan x="9" y="18">${number || ""}</tspan>
            </text>
        </g>
    </svg>
`